import { BasicController, EnvGlobalsHandler } from "@goodgamestudios/core";
import { BasicLanguageFontManager } from "@goodgamestudios/core";
import { IEnvironmentGlobals } from "@goodgamestudios/core";
import { LanguageDataEvent } from "@goodgamestudios/core";
import { TextField } from "@goodgamestudios/createjs-utilities";

import Event = createjs.Event;
/**
 * @deprecated all functions are empty now
 */
export class Poker2LanguageFontManager extends BasicLanguageFontManager {
    private static languageFontManager: Poker2LanguageFontManager;
    public useDefaultFont = true;

    constructor() {
        super();
    }

    public static getInstance(): Poker2LanguageFontManager {
        if (!Poker2LanguageFontManager.languageFontManager) {
            Poker2LanguageFontManager.languageFontManager = new Poker2LanguageFontManager();
        }
        return Poker2LanguageFontManager.languageFontManager;
    }

    public changeFontByLanguage(textField: TextField): void {
        this.poker2ChangeFontByLanguage();
    }

    /**
     * Changes the textformate for a textfield if app switches between a latin and a non-latin font based language.
     *
     *  of the changeFontByLanguage() method allowed only one switch from a latin to a non-latin font:
     * after the switch the textfield lost its formate. That means an another switch back to the last chosen language didn't change the textformate
     * back to its original format.
     *
     * To guarantee a textformate change the original textformate for each textfield will be stored inside an associate array '_textfieldFormates'.
     * This approach may cause problems, but works fine for the
     *
     * @param textField
     */
    public poker2ChangeFontByLanguage(): void {
        //
    }

    public changeFontByLanguageDefault(): void {
        //
    }

    protected onFontSWFLoadComplete(): void {
        //
    }

    protected onLanguageFontReady(): void {
        BasicController.getInstance().dispatchEvent(new LanguageDataEvent(LanguageDataEvent.FONT_LOAD_COMPLETE));
    }

    protected get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set env(value/*:IEnvironmentGlobals*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(BasicLanguageFontManager.prototype, "env").set.call(this, value);
    }
}
